import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/shared/ui';
import { useLogout } from '../model/use-logout';

export function LogoutMenuItem({ onDone }: { onDone?: () => void }) {
  const { t } = useTranslation();
  const logout = useLogout();

  return (
    <MenuItem
      onClick={() => logout.mutate(undefined, { onSettled: onDone })}
      disabled={logout.isPending}
    >
      <ListItemIcon>
        <Icon name="signout" size={16} />
      </ListItemIcon>
      {logout.isPending ? t('header.signingOut') : t('header.signOut')}
    </MenuItem>
  );
}
